Namespace 'Monitoring.Models.SocialContents.GoogleMyBusiness.Builders'

class Monitoring.Models.SocialContents.GoogleMyBusiness.Builders.GoogleMyBusinessAddressBuilder
  setRegionCode: (regionCode) =>
    @regionCode = regionCode

  getRegionCode: =>
    @regionCode

  setAdministrativeArea: (administrativeArea) =>
    @administrativeArea = administrativeArea

  getAdministrativeArea: =>
    @administrativeArea

  setLocality: (locality) =>
    @locality = locality

  getLocality: =>
    @locality

  setSubLocality: (subLocality) =>
    @subLocality = subLocality

  getSubLocality: =>
    @subLocality

  setAddressLines: (addressLines) =>
    @addressLines = addressLines

  getAddressLines: =>
    @addressLines

  build: =>
    new Monitoring.Models.SocialContents.GoogleMyBusiness.GoogleMyBusinessAddress(@)
